var map = {
	"./Air-Travel.svg": [
		878,
		3
	],
	"./Bakeries-Cafe.svg": [
		879,
		4
	],
	"./Car-Rental.svg": [
		880,
		5
	],
	"./Catering.svg": [
		881,
		6
	],
	"./Clothes-Shopping.svg": [
		882,
		7
	],
	"./Convenience-Stores.svg": [
		883,
		8
	],
	"./Drug-Stores.svg": [
		884,
		9
	],
	"./Energy.svg": [
		885,
		10
	],
	"./FOOD.svg": [
		886,
		11
	],
	"./Furniture.svg": [
		887,
		12
	],
	"./General.svg": [
		888,
		13
	],
	"./Groceries.svg": [
		889,
		14
	],
	"./Home.svg": [
		890,
		15
	],
	"./LIVING.svg": [
		891,
		16
	],
	"./Local-Transport.svg": [
		892,
		17
	],
	"./Lodging-Accomodation.svg": [
		893,
		18
	],
	"./OTHER.svg": [
		894,
		19
	],
	"./Online-Shopping.svg": [
		895,
		20
	],
	"./SHOPPING.svg": [
		896,
		21
	],
	"./Service-Stations.svg": [
		897,
		22
	],
	"./Streaming.svg": [
		898,
		23
	],
	"./TRAVEL.svg": [
		899,
		24
	],
	"./Taxi.svg": [
		900,
		25
	],
	"./Train.svg": [
		901,
		26
	],
	"./Travel-Agencies.svg": [
		902,
		27
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 866;
module.exports = webpackAsyncContext;